import React from 'react';
import useServicesPerYearDonutChart from './hooks/useServicesPerYearDonutChart';
import { useServicesChartsDataContext } from './hooks/useServicesChartsDataContext';
import { Donut } from '../../../Common/Charts/Donut';

export const ServicesPerYearDonut = ({ height }) => {
    const { module } = useServicesChartsDataContext();
    const { subtitles, series } = useServicesPerYearDonutChart();

    return (
        <Donut
            labelsOutside
            height={height}
            title={`Distribuição ${module.sectionTitle} no Período`}
            subtitles={subtitles}
            chartData={[]}
            series={series}
        />
    );
};
